import {createFileRoute} from '@tanstack/react-router';

import {assetKeys} from '@/features/Asset/api/queryKeys';
import {getAssetByProject} from '@/features/Asset/api/readAssetByProject';
import {
  annotationKeys,
  projectKeys,
  reportKeys,
} from '@/features/Project/api/queryKeys';
import {getAnnotationStats} from '@/features/Project/api/readAnnotationStats';
import {getProject} from '@/features/Project/api/readProject';
import {getReports} from '@/features/Project/api/readReports';
import {ProjectProfile} from '@/features/Project/components/Profile/ProjectProfile';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/inspections/$projectId')({
  component: ProjectProfile,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(params.projectId);

    return {
      ...context,
      readProjectQuery: {
        queryKey: projectKeys.detail(params.projectId),
        queryFn: () => getProject(params.projectId),
      },
      readAssetByProjectQuery: {
        queryKey: assetKeys.detail(params.projectId),
        queryFn: () => getAssetByProject(params.projectId),
      },
      readAnnotationStats: {
        queryKey: annotationKeys.stats(params.projectId),
        queryFn: () => getAnnotationStats(params.projectId),
      },
      readReports: {
        queryKey: reportKeys.list({projectId: params.projectId}),
        queryFn: () => getReports({projectId: params.projectId}),
      },
    };
  },

  loader({context}) {
    return Promise.all([
      context.queryClient.ensureQueryData(context.readProjectQuery),
      context.queryClient.ensureQueryData(context.readAssetByProjectQuery),
    ]);
  },
});
